import { createBrowserHistory as createHistory } from 'history'

export const history = createHistory();
history.listen(location =>  {
  history.oldLocation = history.currentLocation;
  history.currentLocation = location;
});
